import { AdminAppState } from '../../state';
import { getEventId } from './get-event-id';

export const eventHasId = (eventKey: string) => (
  store: AdminAppState,
): boolean => getEventId(eventKey)(store).trim().length > 0;
